/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  TextField,
  Typography
} from '@material-ui/core';
import { random } from 'lodash';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUploadIdentity';
import AnyButton from '../../components/atoms/AnyButton';
import StepProgressBar from '../../components/atoms/StepProgressBar';
import AddMoreButton from '../../components/atoms/AddMoreButton';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  mt20: {
    marginTop: 20
  },
  ml15: {
    marginLeft: 15
  },
  font16: {
    fontSize: 16
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  bold: {
    fontWeight: 'bold'
  },
  colorBlack: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  description: {
    color: '#707070',
    fontSize: 14
  },
  linkToPrev: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  imageInfo: {
    width: '100%',
    objectFit: 'contain'
  },
  dialog: {
    '& .MuiDialog-paper': {
      margin: 10
    }
  },
  dialogContent: {
    padding: 5
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    isReIdentity: state.accounts.reIdentity
  })),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withState('btnText', 'setBtnText', '入力画面に戻る'),
  withState('numberRegisterCopy', 'setNumberRegisterCopy', 1),
  withState('registerCopy', 'setRegisterCopy', []),
  withState('previewImageRegisterCopy', 'setPreviewImageRegisterCopy', []),
  withState('registerCopyType', 'setRegisterCopyType', []),
  withState('registerCopyErr', 'setRegisterCopyErr', ''),
  withState('numberSealCertificate', 'setNumberSealCertificate', 1),
  withState('sealCertificate', 'setSealCertificate', []),
  withState('previewImageSeal', 'setPreviewImageSeal', []),
  withState('sealCertificateType', 'setSealCertificateType', []),
  withState('sealCertificateErr', 'setSealCertificateErr', ''),
  withState('numberBusinessLicense', 'setNumberBusinessLicense', 1),
  withState('businessLicense', 'setBusinessLicense', []),
  withState('previewImageLicense', 'setPreviewImageLicense', []),
  withState('businessLicenseType', 'setBusinessLicenseType', []),
  withState('businessLicenseName', 'setBusinessLicenseName', []),
  withState('businessLicenseErr', 'setBusinessLicenseErr', ''),
  withState('numberIdentity', 'setNumberIdentity', ''),
  withState('openPopUp1', 'setOpenPopUp1', false),
  withState('openPopUp2', 'setOpenPopUp2', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhance(
  ({
    classes,
    show,
    isReIdentity,
    handleRedirect,
    handleBack,
    proceedToNext,
    numberSealCertificate,
    setNumberSealCertificate,
    sealCertificate,
    setSealCertificate,
    previewImageSeal,
    setPreviewImageSeal,
    sealCertificateType,
    setSealCertificateType,
    sealCertificateErr,
    setSealCertificateErr,
    numberBusinessLicense,
    setNumberBusinessLicense,
    businessLicense,
    setBusinessLicense,
    previewImageLicense,
    setPreviewImageLicense,
    businessLicenseType,
    setBusinessLicenseType,
    // businessLicenseName,
    // setBusinessLicenseName,
    businessLicenseErr,
    setBusinessLicenseErr,
    numberIdentity,
    setNumberIdentity,
    openPopUp1,
    setOpenPopUp1,
    openPopUp2,
    setOpenPopUp2
  }) => {
    const identityParams = {
      businessLicense,
      sealCertificate,
      numberIdentity
    };

    // const validBusinessLicense = () => {
    //   // if (businessLicense.length !== businessLicenseName.length) {
    //   //   setBusinessLicenseErr('書類名称と画像を同時にお願いします。');
    //   //   return 1;
    //   // }
    //   const maxLength =
    //     businessLicense.length > businessLicenseName.length
    //       ? businessLicense.length
    //       : businessLicenseName.length;
    //   for (let i = 0; i < maxLength; i += 1) {
    //     const name = businessLicenseName[i]
    //       ? businessLicenseName[i].trim()
    //       : '';
    //     if (
    //       (businessLicense[i] && name === '') ||
    //       (!businessLicense[i] && name !== '')
    //     ) {
    //       setBusinessLicenseErr('書類名称と画像を同時にお願いします。');
    //       return 1;
    //     }
    //   }
    //   setBusinessLicenseErr('');
    //   return 0;
    // };

    const validBusinessLicense = () => {
      if (
        businessLicense.length === 0 ||
        (businessLicense.length > 0 &&
          businessLicense.filter(item => !!item).length === 0)
      ) {
        setBusinessLicenseErr('必須項目です。');
        return 1;
      }
      setBusinessLicenseErr('');
      return 0;
    };

    const validSealCertificate = () => {
      if (
        sealCertificate.length === 0 ||
        (sealCertificate.length > 0 &&
          sealCertificate.filter(item => !!item).length === 0)
      ) {
        setSealCertificateErr('必須項目です。');
        return 1;
      }
      setSealCertificateErr('');
      return 0;
    };

    const valid = () => {
      const errorCount = validBusinessLicense() + validSealCertificate();
      return errorCount === 0;
    };

    const handleSetSealCertificate = (value, index) => {
      const tmpValue = [...sealCertificate];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificate([...tmpValue]);
    };

    const handleSetSealCertificateType = (value, index) => {
      const tmpValue = [...sealCertificateType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificateType([...tmpValue]);
    };

    const handleSetPreviewImageSeal = (value, index) => {
      const tmpValue = [...previewImageSeal];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageSeal([...tmpValue]);
    };

    const getSealCertificateButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberSealCertificate; i += 1) {
        arrButton.push(
          <FileUpload
            key={random(true)}
            label={`seal-${i}`}
            setFile={handleSetSealCertificate}
            previewImage={previewImageSeal[i]}
            setPreviewImage={handleSetPreviewImageSeal}
            indexNumber={i}
            setType={handleSetSealCertificateType}
            type={sealCertificateType[i]}
          />
        );
      }
      return arrButton;
    };

    const handleSetBusinessLicense = (value, index) => {
      const tmpValue = [...businessLicense];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setBusinessLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseType = (value, index) => {
      const tmpValue = [...businessLicenseType];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setBusinessLicenseType([...tmpValue]);
    };

    const handleSetPreviewImageLicense = (value, index) => {
      const tmpValue = [...previewImageLicense];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setPreviewImageLicense([...tmpValue]);
    };

    // const handleSetBusinessLicenseName = (value, index) => {
    //   const tmpValueName = [...businessLicenseName];
    //   // if (value && value.trim() !== '') {
    //   //   tmpValueName[index] = value;
    //   // } else {
    //   //   tmpValueName.splice(index, 1);
    //   // }
    //   // Keep order, do not remove (splice) item from array
    //   tmpValueName[index] = value ? value.trim() : '';
    //   setBusinessLicenseName([...tmpValueName]);
    // };

    const getBusinessLicenseButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberBusinessLicense; i += 1) {
        arrButton.push(
          <div key={random(true)}>
            {/* <TextField
              label="詳細"
              fullWidth
              className={classes.textField}
              margin="normal"
              defaultValue={
                businessLicenseName[i] ? businessLicenseName[i] : ''
              }
              onBlur={e => {
                handleSetBusinessLicenseName(e.target.value, i);
              }}
            /> */}
            <FileUpload
              label={`license-${i}`}
              setFile={handleSetBusinessLicense}
              previewImage={previewImageLicense[i]}
              setPreviewImage={handleSetPreviewImageLicense}
              indexNumber={i}
              setType={handleSetBusinessLicenseType}
              type={businessLicenseType[i]}
            />
          </div>
        );
      }
      return arrButton;
    };

    return (
      <div className={show ? null : classes.hidden}>
        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography component="h2" variant="h5">
              審査申請情報の入力
            </Typography>
          </div>

          <StepProgressBar currentStep={1} />

          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <Typography variant="body2">
                <b>個人事業主：</b>
                <br />
                「②営業許可書」
                <br />
                「③公共料金の領収書・身分証明書のいずれか」
                <br />
                <br />
                <b>法人：</b>
                <br />
                「②営業許可書」
                <br />
                「③法人の印鑑証明」
                <br />
                「④法人番号」
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <Typography
                variant="body2"
                className={classes.mt20}
                color="textSecondary"
              >
                <span
                  className={`${classes.bold} ${classes.colorBlack} ${
                    classes.font16
                  }`}
                >
                  ② 営業許可証
                </span>
                <br />
                ※風営適正化法による許可・届け出をしている場合はその営業許可証を必ず提出してください。
                <br />
                ※風俗営業の1号営業～4号営業、性風俗関連特殊営業はご登録できかねます。
                <br />
                ※飲食店以外の店舗さまの場合は、登記簿謄本（履歴事項全部証明書）全ページ但し登録店舗の住所の記載があるもの・開業廃業等届書・飲食店の営業許可証に類する「代表者名」「住所」「店舗名」などが確認できる公的な書類、のいずれかを提出してください。
              </Typography>
              {getBusinessLicenseButtons()}
              <AddMoreButton
                disabled={numberBusinessLicense >= 5}
                onClickAction={() =>
                  setNumberBusinessLicense(numberBusinessLicense + 1)
                }
              />
              <ValidationText message={businessLicenseErr} />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <Typography variant="body2" className={classes.mt20}>
                <span
                  className={`${classes.bold} ${classes.colorBlack} ${
                    classes.font16
                  }`}
                >
                  ③
                  個人事業主の場合は下記のいずれか、法人の場合は1.印鑑証明のみ有効
                </span>
                <br />
                <span
                  className={`${classes.bold} ${classes.colorBlack} ${
                    classes.font14
                  }`}
                >
                  1. 印鑑証明（取得から1年以内）
                </span>
                <br />
                <div className={`${classes.ml15} ${classes.font12}`}>
                  ※①の営業許可証に記載の氏名・法人のものに限る
                </div>
                <span
                  className={`${classes.bold} ${classes.colorBlack} ${
                    classes.font14
                  }`}
                >
                  2. 公共料金の領収書（発行から一年以内）
                </span>
                <div className={`${classes.ml15} ${classes.font12}`}>
                  ※①の営業許可証に記載の氏名・法人名と、住所と同一の記載があるものに限る
                </div>
                <span
                  className={`${classes.bold} ${classes.colorBlack} ${
                    classes.font14
                  }`}
                >
                  3. 身分証明書
                </span>
                <div className={`${classes.ml15} ${classes.font12}`}>
                  ※①の営業許可証に記載のある氏名の運転免許証・パスポート・健康保険証のいずれかに限る
                </div>
              </Typography>
              {getSealCertificateButtons()}
              <AddMoreButton
                disabled={numberSealCertificate >= 5}
                onClickAction={() =>
                  setNumberSealCertificate(numberSealCertificate + 1)
                }
              />
              <ValidationText message={sealCertificateErr} />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <AnyButton />
              <Typography
                variant="body2"
                className={`${classes.mt20} ${classes.bold} ${
                  classes.colorBlack
                } ${classes.font14}`}
              >
                ④法人番号（法人の方のみ必須）
              </Typography>
              <TextField
                rows="1"
                type="number"
                placeholder="0123456789012"
                fullWidth
                margin="normal"
                onChange={e => {
                  setNumberIdentity(e.target.value);
                }}
              />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  if (valid()) {
                    proceedToNext({ identityParams });
                  } else {
                    alert('登録情報を正しく入力してください。');
                  }
                }}
              >
                入力情報を確認
              </Button>
            </div>
          </Paper>
        </div>
        <div className={classes.linkToPrev}>
          {isReIdentity ? (
            <Button
              color="primary"
              onClick={() => {
                handleRedirect('/');
              }}
            >
              ログイン画面に戻る
            </Button>
          ) : (
            <Button color="primary" onClick={handleBack}>
              前の画面に戻る
            </Button>
          )}
        </div>
        <Dialog className={classes.dialog} disableScrollLock open={openPopUp1}>
          <DialogContent className={classes.dialogContent}>
            <CardMedia
              component="img"
              image="/images/popup1.jpg"
              className={classes.imageInfo}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="text"
              color="primary"
              onClick={() => setOpenPopUp1(false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog className={classes.dialog} open={openPopUp2}>
          <DialogContent className={classes.dialogContent}>
            <CardMedia
              component="img"
              image="/images/popup2.jpg"
              className={classes.imageInfo}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="text"
              color="primary"
              onClick={() => setOpenPopUp2(false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
